module.exports = __webpack_public_path__ + "files/7f7b2b6a8310ea375835c0805f74c2ea.png";